export default __webpack_public_path__ + "2bf13b17d09412f118b0d2191a04af9d.png";